export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-16-cbee734563bdcf1739030f8ec8966aac.png";